module.exports = __webpack_public_path__ + "img/55.6cfa5856.jpg";